import { z } from "zod";
import { IdType } from "./base.validator";
import { fileMeta } from "./files.validator";
import { paginateSchema } from "./pagination.validator";

export const individualAttendance = z.object({
	lat: z.number(),
	long: z.number(),
	datetime: z.string().datetime(),
	pictureId: IdType,
});
export type IndividualAttendanceDto = z.infer<typeof individualAttendance>

export const createdAttendance = z.object({
	id: IdType,
	userId: IdType,
	day: z.string().datetime(),
	millis: z.number(),
	in: individualAttendance,
	out: individualAttendance.nullish(),
});
export type CreatedAttendanceDto = z.infer<typeof createdAttendance>;

const individualAttendanceRelationship = individualAttendance.extend({
	picture: fileMeta.nullish(),
});
export const createdAttendanceRelationship = createdAttendance.extend({
	in: individualAttendanceRelationship,
	out: individualAttendanceRelationship.nullish(),
});
export type CreatedAttendanceRelationshipDto = z.infer<
	typeof createdAttendanceRelationship
>;

export const paginatedCreatedAttendances = paginateSchema(
	createdAttendanceRelationship
).extend({
	totalHours: z.number(),
});
export type PaginatedCreatedAttendancesDto = z.infer<
	typeof paginatedCreatedAttendances
>;

const individualUserAttendance = individualAttendanceRelationship
	.omit({
		pictureId: true,
	})
	.required({ picture: true });
export const createdUserAttendance = createdAttendanceRelationship.extend({
	in: individualUserAttendance,
	out: individualUserAttendance.nullish(),
});
export type CreatedUserAttendanceDto = z.infer<typeof createdUserAttendance>;

export const findAttendanceFilter = createdAttendance
	.pick({
		id: true,
		userId: true,
	})
	.extend({
		startDate: z.string().datetime(),
		endDate: z.string().datetime(),
	})
	.partial();
export type FindAttendanceFilterDto = z.infer<typeof findAttendanceFilter>;

export const findUserAttendanceFilter = findAttendanceFilter
	.pick({
		startDate: true,
		endDate: true,
	})
	.required();
export type FindUserAttendanceFilterDto = z.infer<
	typeof findUserAttendanceFilter
>;

export const upsertTimelog = createdAttendance
	.omit({ day: true, millis: true })
	.partial()
	.required({ userId: true });
export type UpsertTimelogDto = z.infer<typeof upsertTimelog>;

export const dayLogEntry = createdAttendance.omit({ userId: true });
export const dayLog = z.object({
	day: z.string().datetime(),
	totalMillis: z.number(),
	entries: dayLogEntry.array(),
});
export type DayLog = z.infer<typeof dayLog>;

export const groupedDayAttendance = z.object({
	userId: IdType,
	dayLogs: dayLog.array(),
	totalMillis: z.number(),
});
export type GroupedUserDayAttendanceDto = z.infer<typeof groupedDayAttendance>;
